import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import SegmentDetails from "../../components/segmentDetails";
import SegmentDonors from "../../components/segmentDonorList";
import SegmentsPage from "../../components/segments";
import { SegmentThankYouAdminAddPage, SegmentThankYouAdminsPage } from "../../components/thankYouAdmins/screens";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";
import RequireGiveSpark from "../../components/requireGiveSpark";

const Segments = () => {
  return (
    <ProtectedRoute>
      <main>
      <Helmet title="Segments" />
      <Layout>
        <Routes>
          <Route index element={<SegmentsPage />} />
          <Route path="new" element={<SegmentDetails />} />
          <Route
            path=":segmentId/contacts/:fromSegments"
            element={<SegmentDonors />}
          />
          <Route
            path=":segmentId/thank-you-admins/new"
            element={
              <RequireGiveSpark redirectTo="/segments">
                <SegmentThankYouAdminAddPage />
              </RequireGiveSpark>
            }
          />
          <Route
            path=":segmentId/thank-you-admins"
            element={
              <RequireGiveSpark redirectTo="/segments">
                <SegmentThankYouAdminsPage />
              </RequireGiveSpark>
            }
          />
          <Route path=":segmentId" element={<SegmentDetails />} />
        </Routes>
      </Layout>
      </main>
    </ProtectedRoute>
  );
};

export default Segments;
